import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ItemService {
  private apiUrl = '/items';
  private apiSpringUrl = '/spring/items';

  constructor(private http: HttpService) { }

  get(params?: any): Promise<any> {
    let url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}`;
    if (params != undefined) {
      url = `${url}?${params}`
    }
    return this.http.get(url);
  }

  post(
    ownerId: number,
    itemCd: string,
    itemTx: string,
    lotFl: number,
    uselimitFl: number,
    fragilemarkFl: number,
    upwardmarkFl: number,
    itemlabeluseFl: number,
    arrivlabeluseFl: number,
    shiplabeluseFl: number,
    typeitemCd: string,
    sameitemapplyFl: number,
    typecoldCd: string,
    arriveuselimitNr: number,
    shipuselimitNr: number,
    pcsunitId: number,
    itemabcId: number,
    baracaseCd: string,
    baraamountNr: number,
    pycaseCd: string,
    pycaseamountNr: number,
    bybaracaseCd: string,
    bybaracaseamountNr: number,
    bycaseCd: string,
    bycaseamountNr: number,
    // maxpbinstockNr: number,
    inneramountNr: number,
    innerNr: number,
    caseamountNr: number,
    casespreadNr: number,
    casestackNr: number,
    pcsbarcodeTx: string,
    casebarcodeTx: string,
    lengthNr: number,
    widthNr: number,
    heightNr: number,
    volumeNr: number,
    weightNr: number,
    innerlengthNr: number,
    innerwidthNr: number,
    innerheightNr: number,
    caselengthNr: number,
    casewidthNr: number,
    caseheightNr: number,
    casevolumeNr: number,
    caseweightNr: number,
    typeunitpriceCd: string,
    stockunitpriceNr: number,
    arriveunitpriceNr: number,
    shipunitpriceNr: number,
    depositpriceNr: number,
    bsupppointbaraNr: number,
    bsupplimitbaraNr: number,
    supppointinnercaseNr: number,
    supplimitinnercaseNr: number,
    supppointcaseNr: number,
    supplimitcaseNr: number,
    variation1Tx: string,
    variation2Tx: string,
    variation3Tx: string,
    displaypriceNr: number,
    updprogramCd: string
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl;

    const jsonInput = {
      ownerId: ownerId,
      itemCd: itemCd,
      itemTx: itemTx,
      lotFl: lotFl,
      uselimitFl: uselimitFl,
      fragilemarkFl: fragilemarkFl,
      upwardmarkFl: upwardmarkFl,
      itemlabeluseFl: itemlabeluseFl,
      arrivlabeluseFl: arrivlabeluseFl,
      shiplabeluseFl: shiplabeluseFl,
      typeitemCd: typeitemCd,
      sameitemapplyFl:sameitemapplyFl,
      typecoldCd: typecoldCd,
      arriveuselimitNr: arriveuselimitNr,
      shipuselimitNr: shipuselimitNr,
      pcsunitId: pcsunitId,
      itemabcId: itemabcId,
      baracaseCd: baracaseCd,
      baraamountNr: baraamountNr,
      pycaseCd: pycaseCd,
      pycaseamountNr: pycaseamountNr,
      bybaracaseCd: bybaracaseCd,
      bybaracaseamountNr: bybaracaseamountNr,
      bycaseCd: bycaseCd,
      bycaseamountNr: bycaseamountNr,
      // maxpbinstockNr: maxpbinstockNr,
      inneramountNr: inneramountNr,
      innerNr: innerNr,
      caseamountNr: caseamountNr,
      casespreadNr: casespreadNr,
      casestackNr: casestackNr,
      pcsbarcodeTx: pcsbarcodeTx,
      casebarcodeTx: casebarcodeTx,
      lengthNr: lengthNr,
      widthNr: widthNr,
      heightNr: heightNr,
      volumeNr: volumeNr,
      weightNr: weightNr,
      innerlengthNr: innerlengthNr,
      innerwidthNr: innerwidthNr,
      innerheightNr: innerheightNr,
      caselengthNr: caselengthNr,
      casewidthNr: casewidthNr,
      caseheightNr: caseheightNr,
      casevolumeNr: casevolumeNr,
      caseweightNr: caseweightNr,
      typeunitpriceCd: typeunitpriceCd,
      stockunitpriceNr: stockunitpriceNr,
      arriveunitpriceNr: arriveunitpriceNr,
      shipunitpriceNr: shipunitpriceNr,
      depositpriceNr: depositpriceNr,
      bsupppointbaraNr: bsupppointbaraNr,
      bsupplimitbaraNr: bsupplimitbaraNr,
      supppointinnercaseNr: supppointinnercaseNr,
      supplimitinnercaseNr: supplimitinnercaseNr,
      supppointcaseNr: supppointcaseNr,
      supplimitcaseNr: supplimitcaseNr,
      variation1Tx: variation1Tx,
      variation2Tx: variation2Tx,
      variation3Tx: variation3Tx,
      displaypriceNr: displaypriceNr,
      updprogramCd: updprogramCd
    };

    return this.http.post(url, jsonInput);

  }

  put(
    ownerId: number,
    itemId: number,
    itemCd: string,
    itemTx: string,
    lotFl: number,
    uselimitFl: number,
    fragilemarkFl: number,
    upwardmarkFl: number,
    itemlabeluseFl: number,
    arrivlabeluseFl: number,
    shiplabeluseFl: number,
    typeitemCd: string,
    sameitemapplyFl: number,
    typecoldCd: string,
    arriveuselimitNr: number,
    shipuselimitNr: number,
    pcsunitId: number,
    itemabcId: number,
    baracaseCd: string,
    baraamountNr: number,
    pycaseCd: string,
    pycaseamountNr: number,
    bybaracaseCd: string,
    bybaracaseamountNr: number,
    bycaseCd: string,
    bycaseamountNr: number,
    // maxpbinstockNr: number,
    inneramountNr: number,
    innerNr: number,
    caseamountNr: number,
    casespreadNr: number,
    casestackNr: number,
    pcsbarcodeTx: string,
    casebarcodeTx: string,
    lengthNr: number,
    widthNr: number,
    heightNr: number,
    volumeNr: number,
    weightNr: number,
    innerlengthNr: number,
    innerwidthNr: number,
    innerheightNr: number,
    caselengthNr: number,
    casewidthNr: number,
    caseheightNr: number,
    casevolumeNr: number,
    caseweightNr: number,
    typeunitpriceCd: string,
    stockunitpriceNr: number,
    arriveunitpriceNr: number,
    shipunitpriceNr: number,
    depositpriceNr: number,
    bsupppointbaraNr: number,
    bsupplimitbaraNr: number,
    supppointinnercaseNr: number,
    supplimitinnercaseNr: number,
    supppointcaseNr: number,
    supplimitcaseNr: number,
    variation1Tx: string,
    variation2Tx: string,
    variation3Tx: string,
    displaypriceNr: number,
    updprogramCd: string,
    updcounterNr: number,
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${itemId}`;

    const jsonInput = {
      ownerId: ownerId,
      itemId: itemId,
      itemCd: itemCd,
      itemTx: itemTx,
      lotFl: lotFl,
      uselimitFl: uselimitFl,
      fragilemarkFl: fragilemarkFl,
      upwardmarkFl: upwardmarkFl,
      itemlabeluseFl: itemlabeluseFl,
      arrivlabeluseFl: arrivlabeluseFl,
      shiplabeluseFl: shiplabeluseFl,
      typeitemCd: typeitemCd,
      sameitemapplyFl:sameitemapplyFl,
      typecoldCd: typecoldCd,
      arriveuselimitNr: arriveuselimitNr,
      shipuselimitNr: shipuselimitNr,
      pcsunitId: pcsunitId,
      itemabcId: itemabcId,
      baracaseCd: baracaseCd,
      baraamountNr: baraamountNr,
      pycaseCd: pycaseCd,
      pycaseamountNr: pycaseamountNr,
      bybaracaseCd: bybaracaseCd,
      bybaracaseamountNr: bybaracaseamountNr,
      bycaseCd: bycaseCd,
      bycaseamountNr: bycaseamountNr,
      // maxpbinstockNr: maxpbinstockNr,
      inneramountNr: inneramountNr,
      innerNr: innerNr,
      caseamountNr: caseamountNr,
      casespreadNr: casespreadNr,
      casestackNr: casestackNr,
      pcsbarcodeTx: pcsbarcodeTx,
      casebarcodeTx: casebarcodeTx,
      lengthNr: lengthNr,
      widthNr: widthNr,
      heightNr: heightNr,
      volumeNr: volumeNr,
      weightNr: weightNr,
      innerlengthNr: innerlengthNr,
      innerwidthNr: innerwidthNr,
      innerheightNr: innerheightNr,
      caselengthNr: caselengthNr,
      casewidthNr: casewidthNr,
      caseheightNr: caseheightNr,
      casevolumeNr: casevolumeNr,
      caseweightNr: caseweightNr,
      typeunitpriceCd: typeunitpriceCd,
      stockunitpriceNr: stockunitpriceNr,
      arriveunitpriceNr: arriveunitpriceNr,
      shipunitpriceNr: shipunitpriceNr,
      depositpriceNr: depositpriceNr,
      bsupppointbaraNr: bsupppointbaraNr,
      bsupplimitbaraNr: bsupplimitbaraNr,
      supppointinnercaseNr: supppointinnercaseNr,
      supplimitinnercaseNr: supplimitinnercaseNr,
      supppointcaseNr: supppointcaseNr,
      supplimitcaseNr: supplimitcaseNr,
      variation1Tx: variation1Tx,
      variation2Tx: variation2Tx,
      variation3Tx: variation3Tx,
      displaypriceNr: displaypriceNr,
      updprogramCd: updprogramCd,
      updcounterNr: updcounterNr
    };

    return this.http.put(url, jsonInput);
  }

  // node版は廃止済み
  // delete(itemId: number): Promise<any> {
  //   const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/${itemId}`;
  //   return this.http.delete(url);
  // }

  updateImages(itemId: Number, images: String): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/images`;
    const jsonInput = {
      itemId: itemId,
      images: images
    };
    return this.http.put(url, jsonInput);
  }

  deleteImageFile(filename: String): Promise<any> {
    const url = `${environment.baseUrl}/image/delete`;
    const jsonInput = {
      filename: filename
    };
    return this.http.post(url, jsonInput);
  }

  deleteForSpring(itemId: Number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/delete/${itemId}`;
    return this.http.delete(url);
  }

  /**
   * 商品マスタ検索（Spring版）
   * AG-Gridのフィルタ・ソート・ページネーション対応
   */
  search(params: {
    ownerId?: number,
    startRow?: number,
    endRow?: number,
    colId?: string,
    sort?: string,
    filterModel?: any
  }): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/searchItemList`;
    return this.http.post(url, params);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/item/item.service.ts